import "./Tasks.css";

import { OrganisationTypeConstants } from "../../../../constants";
import { CompleteTaskModal, WorkflowTaskPanel } from "../../../../templates/WorkflowTaskPanel";
import { Column, CursorDataGrid, Row } from "../../../../widget";
import { useTasks } from "./useTasks";

const Tasks = (): JSX.Element => {
  const {
    refreshTasks,
    workflow,
    handleRefresh,

    selectedPanelTask,
    showWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,

    selectedCompleteTask,
    showCompleteTaskModal,
    handleCloseCompleteTaskModal,

    tasksOnChange,
    isTasksLoading,
    columns,
    defaultSortingCriteria,
    currentUserType,
  } = useTasks();

  return (
    <div className="TemplateTabCard">
      <Row spacingV="ml">
        <Column span={12}>
          <Row spacingV="ml" justify="between" align="center">
            <Column span={6}>
              <h2>Tasks</h2>
            </Column>
          </Row>
          <CursorDataGrid
            columns={columns}
            clientSide={false}
            filterable
            sortable
            onChange={tasksOnChange}
            data={[]}
            pagination={{ pageSize: 10 }}
            refresh={refreshTasks}
            noDataMessage="No tasks to display"
            dataIsLoading={isTasksLoading}
            defaultSortingCriteria={defaultSortingCriteria}
            variant={currentUserType === OrganisationTypeConstants.ASSET_MANAGER ? "seed" : "default"}
          />
        </Column>
      </Row>
      <WorkflowTaskPanel
        task={selectedPanelTask}
        currentStepUuid={selectedPanelTask?.step.uuid}
        workflow={workflow}
        show={showWorkflowTaskPanel}
        refresh={refreshTasks}
        handleRefresh={handleRefresh}
        onClose={handleCloseWorkflowTaskPanel}
      />
      {selectedCompleteTask && (
        <CompleteTaskModal
          task={selectedCompleteTask}
          show={showCompleteTaskModal}
          closeModal={handleCloseCompleteTaskModal}
          closePanel={handleCloseCompleteTaskModal}
          handleRefresh={handleRefresh}
        />
      )}
    </div>
  );
};

export default Tasks;
